import React, { useEffect } from 'react';
import { Router } from '@reach/router';
import type { RouteComponentProps } from '@reach/router';
import { navigate } from 'gatsby';
import { useLiveSessions } from '@youga/youga-client-api';

import TrainingSessionPage from '../TrainingSessionSection/TrainingSessionPage';
import PoseComparisonSection from '../PoseComparisonSection/PoseComparisonSection';
import PoseComparisonOverviewSection from '../PoseComparisonOverviewSection/PoseComparisonOverviewSection';
import HomeSection from '../HomeSection/HomeSection';
import CourseOverviewSection from '../CourseOverviewSection/CourseOverviewSection';
import CourseDetailSection from '../CourseDetailSection/CourseDetailSection';
import InstructorDetailSection from '../InstructorDetailSection/InstructorDetailSection';
import ExplainerSection from '../ExplainerSection/ExplainerSection';
import MyAccountSection from '../MyAccountSection/MyAccountSection';
import FinishSessionSection from '../FinishSessionSection/FinishSessionSection';
import MobileGate from '../MobileGate/MobileGate';
import LoadingGate from '../LoadingGate/LoadingGate';
import SubscriptionGate from '../SubscriptionGate/SubscriptionGate';
import useGateInformation, {
  GATE_INFORMATION,
} from '../../../hooks/useGateInformation';
import useServiceWorkerMessages from '../../../hooks/useServiceWorkerMessages';
import useSubscribePushManager from '../../../hooks/useSubscribePushManager';
import JourneyProgressPage from '../../03_organisms/JourneyProgress/JourneyProgressPage';
import MeinBereichSection from '../MeinBereichSection/MeinBereichSection';
import AccountGate from '../AccountGate/AccountGate';
import CookieManager from '../../02_molecules/CookieManager/CookieManager';
import StripeGate from '../StripeGate/StripeGate';
import { useStripe } from '../../../context/StripeContext';
import useSubscriptionStatus from '../../../hooks/useSubscriptionStatus';
import LiveTrainingsPage from '../LiveTrainings/LiveTrainingsPage';

interface ProtectedTrainingSessionProps extends RouteComponentProps {
  videoId?: string;
}

const ProtectedTrainingSessionPage: React.FC<ProtectedTrainingSessionProps> = (
  props,
) => {
  const { hasFullAppAccess, isValidating } = useSubscriptionStatus();
  const { setIsStripePayment } = useStripe();

  useEffect(() => {
    if (!isValidating && !hasFullAppAccess) {
      void navigate('/app', { replace: true });
      setIsStripePayment(true);
    }
  }, [hasFullAppAccess, isValidating, setIsStripePayment]);

  if (isValidating || !hasFullAppAccess) return null;

  return <TrainingSessionPage {...props} />;
};

const AppSection: React.FC = () => {
  const { isStripePayment } = useStripe();
  const { featureEnabled } = useLiveSessions();

  const gate = useGateInformation();
  console.log({ gate });
  useSubscribePushManager();
  useServiceWorkerMessages();
  if (isStripePayment) {
    return <StripeGate />;
  }
  switch (gate) {
    case GATE_INFORMATION.MOBILE:
      return <MobileGate />;

    case GATE_INFORMATION.ACCOUNT_INVALID:
      return <AccountGate />;

    case GATE_INFORMATION.LICENSE:
      return <SubscriptionGate />;

    case GATE_INFORMATION.LOADING:
      return <LoadingGate />;

    case GATE_INFORMATION.PASS:
    default:
      return (
        <Router basepath="/app">
          <HomeSection path="/" />
          <ExplainerSection path="/how-it-works" />
          <MyAccountSection path="/my-account" />
          <CookieManager path="/my-account/cookie-manager" />
          <MeinBereichSection path="/mein-bereich" />
          <ProtectedTrainingSessionPage path="/session/:videoId" />
          <FinishSessionSection path="/finish-session/:trainingSessionId/:rawFeedback" />
          <PoseComparisonSection path="/pose-comparison/:sessionId" />
          <PoseComparisonOverviewSection path="/pose-comparison" />
          <CourseOverviewSection path="/courses" />
          {featureEnabled && <LiveTrainingsPage path="/live" />}
          <CourseDetailSection
            path="/course-detail/:courseId"
            key={'asdasdasda'}
          />
          <CourseDetailSection
            path="/course-detail/:courseId/:startIntro"
            key={'asdasdasasadsada'}
          />
          <InstructorDetailSection path="/instructor-detail/:instructorId" />
          <JourneyProgressPage path="/journey/:courseId" />
        </Router>
      );
  }
};

export default AppSection;
